<app-sidebar></app-sidebar>

<div class="layout-sidebar-push layout-body">
    <app-loading height="300px" *ngIf="(!offer || loading)"></app-loading>

    <!-- Perks-backed dashboard: the matching Performances tab, scoped to this offer -->

    <div *ngIf="offer && dashboardTab">
        <div class="head">
            <h2 class="head-main">
                {{ 'offers.metrics.heading' | translate }} / {{ offer.reference }}
            </h2>

            <div class="head-right">
                <app-datepicker-full
                    [dates]="dashboard.dates"
                    [period]="'LIFETIME'"
                    [periods]="['LIFETIME']"
                    [bounds]="bounds"
                    (changeDates)="onDashboardDatesChange()">
                </app-datepicker-full>
                <div class="head-actions">
                    <a class="button button-primary" (click)="onDashboardExport()">{{ 'shared.button.export' | translate }}</a>
                    <a class="button button-basic" goBack="/offers">{{ 'shared.button.back' | translate }}</a>
                </div>
            </div>
        </div>

        <app-loading *ngIf="dashboardLoading"></app-loading>

        <div class="card" *ngIf="!dashboardLoading && dashboardError">
            <div class="card-body">
                <div class="alert-empty">
                    <p>{{ 'offers.metrics.load-error' | translate }}</p>
                </div>
            </div>
        </div>

        <div *ngIf="!dashboardLoading && !dashboardError && dashboardTab === 'REWARDS'">
            <div class="card">
                <div class="card-body">
                    <div class="squares squares-25">
                        <app-metric-tile key="dashboard.metrics.total-rewarded" [value]="dashboardData?.rewardedCount"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.total-playground" [value]="dashboardData?.playgroundAmount" [isCurrency]="true"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.total-commission" [value]="dashboardData?.feesAmount" [isCurrency]="true"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.total-revenue" [value]="dashboardData?.revenueAmount" [isCurrency]="true"></app-metric-tile>
                    </div>

                    <div class="squares squares-25">
                        <app-metric-tile key="dashboard.metrics.number-of-rewards" [value]="dashboardData?.rewardCount"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.reward-amount" [value]="dashboardData?.rewardAmount" [isCurrency]="true"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.average-reward-amount" [value]="dashboardData?.rewardAverageAmount" [isCurrency]="true" format="1.0-2"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.average-basket" [value]="dashboardData?.averageBasket" [isCurrency]="true" format="1.0-2"></app-metric-tile>
                    </div>
                </div>
            </div>

            <app-dashboard-chart-performance
                heading="dashboard.charts.reward-amount-commission"
                [data]="dashboardData?.feesTimeseries"
                [granularity]="chartGranularity"
                [isCurrency]="true">
            </app-dashboard-chart-performance>

            <app-dashboard-chart-performance
                heading="dashboard.charts.rewarded-consumers"
                [data]="dashboardData?.rewardedTimeseries"
                [granularity]="chartGranularity">
            </app-dashboard-chart-performance>
        </div>

        <div *ngIf="!dashboardLoading && !dashboardError && dashboardTab === 'VOUCHERS'">
            <div class="card">
                <div class="card-body">
                    <div class="squares squares-33">
                        <app-metric-tile key="dashboard.metrics.total-vouchers" [value]="dashboardData?.vouchersCount"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.total-voucher-value" [value]="dashboardData?.vouchersAmount" [isCurrency]="true"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.total-voucher-sell" [value]="dashboardData?.vouchersSellAmount" [isCurrency]="true"></app-metric-tile>
                    </div>

                    <div class="squares squares-50">
                        <app-metric-tile key="dashboard.metrics.total-voucher-discount" [value]="dashboardData?.discountAmount" [isCurrency]="true"></app-metric-tile>
                        <app-metric-tile key="dashboard.metrics.total-voucher-commission" [value]="dashboardData?.feesAmount" [isCurrency]="true"></app-metric-tile>
                    </div>
                </div>
            </div>

            <app-dashboard-chart-performance
                heading="dashboard.charts.voucher-discount"
                [data]="dashboardData?.discountTimeseries"
                [granularity]="chartGranularity"
                [isCurrency]="true">
            </app-dashboard-chart-performance>

            <app-dashboard-chart-performance
                heading="dashboard.charts.voucher-by-consumers"
                [data]="dashboardData?.consumersCountTimeseries"
                [granularity]="chartGranularity">
            </app-dashboard-chart-performance>

            <app-dashboard-chart-performance
                heading="dashboard.charts.vouchers"
                [data]="dashboardData?.vouchersCountTimeseries"
                [granularity]="chartGranularity">
            </app-dashboard-chart-performance>
        </div>
    </div>

    <div *ngIf="offer && metrics && !dashboardTab">
        <div class="head">
            <h2 class="head-main">
                {{ 'offers.metrics.heading' | translate }} / {{ offer.reference }}
            </h2>

            <div class="head-right">
                <a class="button button-primary" (click)="onDownload(metrics.meta.download_url)">{{ 'shared.button.export' | translate }}</a>
                <a class="button button-basic" goBack="/offers">{{ 'shared.button.back' | translate }}</a>
            </div>
        </div>

        <!-- Top values Cashback -->

        <div class="card" *ngIf="offer.type === 'CASHBACK'">
            <div class="card-header">
                <h3 style="flex:1">{{ 'offers.metrics.heading.performance' | translate }}</h3>
                <div>
                    {{ 'offers.metrics.from-beginning-to' | translate: { end: (getEndDate() | localizedDate : 'shortDate') } }}
                </div>
            </div>

            <div class="card-body">
                <div class="squares squares-25">
                    <div class="square">
                        <fieldset class="square-big">
                            <legend class="square-legend">
                                {{ 'shared.label.total-spent' | translate }}
                                <app-tooltip message="shared.label.total-spent-hint" position="bottom"></app-tooltip>
                            </legend>
                            <p class="square-value">{{ metrics.total.total_spent | number : '1.2-2' }}€</p>
                        </fieldset>
                        <fieldset class="square-small">
                            <legend class="square-legend">
                                {{ 'shared.label.average-basket' | translate }}
                                <app-tooltip message="shared.label.average-basket-hint" position="bottom"></app-tooltip>
                            </legend>
                            <p class="square-value">{{ metrics.total.average_spent | number : '1.2-2' }}€</p>
                        </fieldset>
                    </div>

                    <div class="square">
                        <fieldset class="square-big">
                            <legend class="square-legend">
                                {{ 'shared.label.total-redemption' | translate }}
                                <app-tooltip message="shared.label.total-redemption-hint" position="bottom"></app-tooltip>
                            </legend>
                            <p class="square-value">{{ metrics.total.redemptions | number : '1.0-0' }}</p>
                        </fieldset>
                        <fieldset class="square-small">
                            <legend class="square-legend">
                                {{ 'shared.label.redemption-rate' | translate }}
                                <app-tooltip message="shared.label.redemption-rate-hint" position="bottom"></app-tooltip>
                            </legend>
                            <p class="square-value">{{ metrics.total.redemption_rate | number : '1.0-2' }}</p>
                        </fieldset>
                    </div>

                    <div class="square">
                        <fieldset class="square-big">
                            <legend class="square-legend">
                                {{ 'shared.label.total-cashback' | translate }}
                                <app-tooltip message="shared.label.total-cashback-hint" position="bottom"></app-tooltip>
                            </legend>
                            <p class="square-value">{{ metrics.total.total_cashback | number : '1.2-2' }}€</p>
                        </fieldset>
                        <fieldset class="square-small">
                            <legend class="square-legend">
                                {{ 'shared.label.total-commissions' | translate }}
                                <app-tooltip message="shared.label.total-commissions-hint" position="bottom"></app-tooltip>
                            </legend>
                            <p class="square-value">{{ metrics.total.fees | number : '1.0-2' }}€</p>
                        </fieldset>
                    </div>

                    <div class="square">
                        <fieldset class="square-big square-fullheight">
                            <legend class="square-legend">
                                {{ 'shared.label.reward-average' | translate }}
                                <app-tooltip message="shared.label.reward-average-hint" position="left"></app-tooltip>
                            </legend>
                            <p class="square-value">
                                {{ metrics.total.average_cashback | number : '1.2-2' }}€
                            </p>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>

        <div class="scope-date-filter">
            <div class="drop-buttons-container">
                <div class="widget widget-datepicker" (click)="onToggleFilters()">
                    <input
                        readonly
                        type="text"
                        value="{{ 'shared.date.month.' + (filters.month - 1) | translate }} {{ year }} ({{ ('shared.granularity.' + filters.granularity | translate) }})">
                    <i class="widget-icon i i-calendar"></i>
                </div>

                <div class="drop-buttons" [hidden]="!filtersShown">
                    <button class="button button-block button-basic has-navigation-icons">
                        <i class="i-prev" (click)="onPrevMonth()"></i>
                        {{ 'shared.date.month.' + (filters.month - 1) | translate }}
                        <i class="i-next" (click)="onNextMonth()"></i>
                    </button>

                    <button class="button button-block button-basic has-navigation-icons">
                        <i class="i-prev" (click)="onPrevYear()" [class.disabled]="!hasPrevYear()"></i>
                        {{ filters.year }}
                        <i class="i-next" (click)="onNextYear()" [class.disabled]="!hasNextYear()"></i>
                    </button>

                    <button class="button button-block button-primary" (click)="onClickGranularity()">
                        {{ 'shared.granularity.' + filters.granularity | translate }}
                    </button>

                    <div class="buttons">
                        <button class="button button-basic" (click)="onCancelFilter()">{{ 'shared.button.cancel' | translate }}</button>
                        <button class="button button-primary" (click)="onConfirmFilter()">{{ 'shared.button.confirm' | translate }}</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Top value Coupons -->

        <div class="card" *ngIf="offer.type !== 'CASHBACK'">
            <div class="card-header">
                {{ 'offers.metrics.heading.performance' | translate }}
            </div>
            <div class="card-body">
                <div class="squares squares-25">
                    <div class="square">
                        <fieldset class="square-big">
                            <legend class="square-legend">
                                {{ 'shared.label.total-activations' | translate }}
                                <app-tooltip message="shared.label.total-activations-hint" position="bottom"></app-tooltip>
                            </legend>
                            <p class="square-value">{{ metrics.total.activations | number : '1.0-0' }}</p>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>

        <!--Activations -->

        <div class="card" *ngIf="offer.type !== 'CASHBACK'">
            <div class="card-header">
                {{ 'offers.metrics.heading.activations' | translate }}
            </div>
            <div class="card-body">
                <app-loading height="300px" *ngIf="loadingMetrics"></app-loading>

                <ngx-chartjs *ngIf="!loadingMetrics"
                    type="bar"
                    [redraw]="!loadingMetrics"
                    [data]="activationsData"
                    [options]="chartOptions"
                    [height]="300">
                </ngx-chartjs>
            </div>
        </div>

        <!-- total spend -->

        <div class="card" *ngIf="offer.type === 'CASHBACK'">
            <div class="card-header">
                {{ 'offers.metrics.heading.total-spent' | translate }}
                <app-tooltip message="offers.metrics.heading.total-spent-hint" position="bottom"></app-tooltip>
            </div>
            <div class="card-body">
                <app-loading height="300px" *ngIf="loadingMetrics"></app-loading>

                <ngx-chartjs *ngIf="!loadingMetrics"
                    type="bar"
                    [redraw]="!loadingMetrics"
                    [data]="totalSpentData"
                    [options]="chartOptions"
                    [height]="300">
                </ngx-chartjs>
            </div>
        </div>

        <!-- average spent -->

        <div class="card" *ngIf="offer.type === 'CASHBACK'">
            <div class="card-header">
                {{ 'offers.metrics.heading.average-spent' | translate }}
                <app-tooltip message="offers.metrics.heading.average-spent-hint" position="bottom"></app-tooltip>
            </div>
            <div class="card-body">
                <app-loading height="400px" *ngIf="loadingMetrics"></app-loading>

                <ngx-chartjs *ngIf="!loadingMetrics"
                    type="bar"
                    [redraw]="!loadingMetrics"
                    [data]="averageSpentData"
                    [options]="averageSpentOptions"
                    [height]="400">
                </ngx-chartjs>
            </div>
        </div>

        <!-- Cashback -->

        <div class="card" *ngIf="offer.type === 'CASHBACK'">
            <div class="card-header">
                {{ 'offers.metrics.heading.cashback' | translate }}
                <app-tooltip message="offers.metrics.heading.cashback-hint" position="bottom"></app-tooltip>
            </div>
            <div class="card-body">
                <app-loading height="300px" *ngIf="loadingMetrics"></app-loading>

                <ngx-chartjs *ngIf="!loadingMetrics"
                    type="line"
                    [redraw]="!loadingMetrics"
                    [data]="cashbackData"
                    [options]="cashbackOptions"
                    [height]="300">
                </ngx-chartjs>
            </div>
        </div>

        <!-- commissions -->

        <div class="card" *ngIf="offer.type === 'CASHBACK'">
            <div class="card-header">
                {{ 'offers.metrics.heading.commissions' | translate }}
                <app-tooltip message="offers.metrics.heading.commissions-hint" position="bottom"></app-tooltip>
            </div>
            <div class="card-body">
                <app-loading height="300px" *ngIf="loadingMetrics"></app-loading>

                <ngx-chartjs *ngIf="!loadingMetrics"
                    type="bar"
                    [redraw]="!loadingMetrics"
                    [data]="commissionData"
                    [options]="chartOptions"
                    [height]="300">
                </ngx-chartjs>
            </div>
        </div>

        <!-- overtime -->

        <div class="card">
            <div class="card-header">
                {{ 'offers.metrics.heading.overtime' | translate }}
                <app-tooltip message="offers.metrics.heading.overtime-hint" position="bottom"></app-tooltip>
            </div>
            <div class="card-body">
                <!-- SEPARATOR -->
                <app-loading height="400px" *ngIf="loadingMetrics"></app-loading>

                <div class="chart-block" *ngIf="!loadingMetrics">
                    <div class="chart-cols">
                        <div class="chart-col">
                            <label>
                                <input type="checkbox" [(ngModel)]="filters.views.t4" (ngModelChange)="onChangeViewFilter()" />
                                {{ 'shared.label.redemption' | translate }}
                                <app-tooltip message="shared.label.redemption-hint" position="bottom"></app-tooltip>
                            </label>
                            <strong>{{ (metrics.total.redemptions || 0) | number : '1.0-0' }}</strong>
                            <ngx-chartjs
                                type="line"
                                [redraw]="!loadingMetrics"
                                [data]="viewsDataSmall4"
                                [options]="viewsSmallOptions"
                                [height]="75">
                            </ngx-chartjs>
                        </div>

                        <div class="chart-col">
                            <label>
                                <input type="checkbox" [(ngModel)]="filters.views.t5" (ngModelChange)="onChangeViewFilter()" />
                                {{ 'shared.label.activations' | translate }}
                                <app-tooltip message="shared.label.activations-hint" position="bottom"></app-tooltip>
                            </label>
                            <strong>&nbsp;</strong>
                            <ngx-chartjs
                                type="line"
                                [redraw]="!loadingMetrics"
                                [data]="viewsDataSmall5"
                                [options]="viewsSmallOptions"
                                [height]="75">
                            </ngx-chartjs>
                        </div>
                    </div>

                    <ngx-chartjs
                        type="line"
                        [redraw]="!loadingMetrics"
                        [data]="viewsData.data3"
                        [options]="viewsOptions"
                        [height]="400">
                    </ngx-chartjs>
                </div>
            </div>
        </div>
    </div>
</div>
